import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";

export function ShowEventType({ state }: { state: ICalendarEventEditorState }) {
    const displayText = state.calendarEvent.isRepeating
        ? `repeating event`
        : `single event`;

    const icon = state.calendarEvent.isRepeating
        ? EGlyphicon.repeat
        : EGlyphicon["arrow-down"];

    return (
        <div
            className={StyleClassAuto({
                margin: `0px 0px 15px 0px`,
                opacity: 0.5,
            })}
        >
            <Glyphicon icon={icon} />
            <span
                className={StyleClassAuto({
                    marginLeft: `5px`,
                })}
            >
                {displayText}
            </span>
        </div>
    );
}
